import { render, staticRenderFns } from "./ClientSubmenu.vue?vue&type=template&id=7afdbe4e"
import script from "./ClientSubmenu.vue?vue&type=script&lang=js"
export * from "./ClientSubmenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports